import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import ScrapeDetail from './components/ScrapeDetail';
import TranslationDetail from './components/TranslationDetail';
import BatchWorkflow from './components/BatchWorkflow';
import BatchJobDetail from './components/BatchJobDetail';
import Layout from './components/Layout';

function App() {
  const isAuthenticated = () => {
    const userId = localStorage.getItem('userId');
    const isAuth = userId !== null && userId !== undefined;
    console.log('isAuthenticated check - userId:', userId, 'result:', isAuth);
    return isAuth;
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              <Layout>
                <Dashboard />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/scrape/:taskId"
          element={
            isAuthenticated() ? (
              <Layout>
                <ScrapeDetail />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/translation/:taskId"
          element={
            isAuthenticated() ? (
              <Layout>
                <TranslationDetail />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/batch"
          element={
            isAuthenticated() ? (
              <Layout>
                <BatchWorkflow />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/batch/:batchJobId"
          element={
            isAuthenticated() ? (
              <Layout>
                <BatchJobDetail />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
        <Route
          path="/dashboard"
          element={
            isAuthenticated() ? (
              <Layout>
                <Dashboard />
              </Layout>
            ) : (
              <Navigate to="/login" />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App; 